import * as React from 'react';
import styled from 'styled-components';
import colors from '../colors';

const DIMarketing: React.SFC<{className?: string}> = ({ className }) => (
    <Wrapper className={className}>
        Engineered by{' '}
        <a
            target="blank"
            href="https://www.dealerinspire.com/conversations-live-chat-messaging-platform-with-ai/?utm_source=chat-embed"
        >
            Dealer Inspire
        </a>
    </Wrapper>
);

export default DIMarketing;

const Wrapper = styled.div`
    font-size: 10px;
    font-weight: 400;
    text-align: right;
    color: ${colors.darkGray};
    a {
        color: ${colors.blue};
        text-decoration: none;
        &:hover {
            text-decoration: underline;
        }
    }
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Shared/DIMarketing.tsx